import s from "./highrise1601.mjs";
import u from "./highrise1337.mjs";
function o(r, e) {
  var t = -1, a = u(r) ? Array(r.length) : [];
  return s(r, function(f, i, n) {
    a[++t] = e(f, i, n);
  }), a;
}
export {
  o as default
};
